export const PRODUCT_ACTION_TYPE = {
    ADD_PRODUCTS: 'add_product_list',
    ADD_CARD: 'add_card',
    INCREASE_ITEM: 'increase_item',
    DECREASE_ITEM: 'decrease_item',
    RESET_ITEM: 'reset_item',
    UPDATE_ITEM: 'update_item',
    REMOVE_ITEM: 'remove_item'
}